import {
  Book,
  Boxes,
  Calendar,
  DraftingCompass,
  Factory,
  FileText,
  Inbox,
  LayoutDashboard,
  Package,
  Palette,
  Settings,
  Settings2,
  ShieldCheck,
  ShoppingCart,
  Truck,
  User,
  Users,
  Warehouse,
  type LucideIcon,
} from "lucide-react";

/** Map BE `iconKey` (kebab) → Lucide. Unknown → Boxes. */
const BY_KEY: Record<string, LucideIcon> = {
  "layout-dashboard": LayoutDashboard,
  inbox: Inbox,
  "shopping-cart": ShoppingCart,
  package: Package,
  palette: Palette,
  warehouse: Warehouse,
  "shield-check": ShieldCheck,
  calendar: Calendar,
  factory: Factory,
  "drafting-compass": DraftingCompass,
  "file-text": FileText,
  book: Book,
  users: Users,
  settings: Settings,
  "settings-2": Settings2,
  user: User,
};

/** Fallback when API omits iconKey — match legacy OpsShell labels. */
const BY_LABEL: Record<string, LucideIcon> = {
  "Tổng quan": LayoutDashboard,
  "Công việc": Inbox,
  "Bán hàng": ShoppingCart,
  "Mua hàng": Package,
  "Giao hàng": Truck,
  Kho: Warehouse,
  "Chất lượng": ShieldCheck,
  "Kế hoạch": Calendar,
  "Sản xuất": Factory,
  "Kỹ thuật": DraftingCompass,
  "Hồ sơ": FileText,
  "Danh mục": Book,
  "Quản trị": Settings2,
  "Cấu hình hệ thống": Settings,
  "Cá nhân": User,
};

export function iconForNavGroup(
  iconKey: string | null | undefined,
  label: string,
): LucideIcon {
  if (iconKey) {
    const hit = BY_KEY[iconKey.trim().toLowerCase()];
    if (hit) return hit;
  }
  return BY_LABEL[label] ?? Boxes;
}
